import {
    CLEAR_TAXPAYER_ADDRESS_NEW_ACTION,
    TAXPAYER_ADDRESS_NEW_LEVEL1,
    TAXPAYER_ADDRESS_NEW_LEVEL2,
    TAXPAYER_ADDRESS_NEW_LEVEL3,
    TAXPAYER_ADDRESS_NEW_LEVEL4,
    TAXPAYER_ADDRESS_NEW_LEVEL5,
} from '../../../actionType';

export default function (state = {districtCityNew: undefined,
    countyMunicipalityNew: undefined,
    subCountyTownCouncilDivisionNew: undefined,
    parishNew: undefined,
    villageLocalCouncilZoneNew: undefined,}, action) {
    switch (action.type) {
        case TAXPAYER_ADDRESS_NEW_LEVEL1:
            return {
                ...state,
                districtCityNew:action.districtCityNew,
                countyMunicipalityNew: undefined,
                subCountyTownCouncilDivisionNew: undefined,
                parishNew: undefined,
                villageLocalCouncilZoneNew: undefined,
            };
        case TAXPAYER_ADDRESS_NEW_LEVEL2:
            return {
                ...state,
                countyMunicipalityNew:action.countyMunicipalityNew,
                subCountyTownCouncilDivisionNew: undefined,
                parishNew: undefined,
                villageLocalCouncilZoneNew: undefined,
            };
        case TAXPAYER_ADDRESS_NEW_LEVEL3:
            return {
                ...state,
                subCountyTownCouncilDivisionNew:action.subCountyTownCouncilDivisionNew,
                parishNew: undefined,
                villageLocalCouncilZoneNew: undefined,
            };
        case TAXPAYER_ADDRESS_NEW_LEVEL4:
            return {
                ...state,
                parishNew:action.parishNew,
                villageLocalCouncilZoneNew: undefined,
            };
        case TAXPAYER_ADDRESS_NEW_LEVEL5:
            return {
                ...state,
                villageLocalCouncilZoneNew:action.villageLocalCouncilZoneNew,
            };
        case CLEAR_TAXPAYER_ADDRESS_NEW_ACTION:
            return {districtCityNew: undefined,
                countyMunicipalityNew: undefined,
                subCountyTownCouncilDivisionNew: undefined,
                parishNew: undefined,
                villageLocalCouncilZoneNew: undefined,};
        default:
            return state;
    }
}
